"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPropertiesListToCommon = void 0;
const mapPropertiesListToCommonSites_1 = require("./mapPropertiesListToCommonSites");
const mapPropertiesToCommon_1 = require("./mapPropertiesToCommon");
const mapPropertiesListToCommon = ({ oneSearchResponse, summariesResponse, language, elements, }) => {
    const { total, aggregations, searchResults, rhsLevel } = oneSearchResponse;
    const hasSiteFeatures = aggregations.siteFeatures.length > 0;
    const aggregationsRegions = 'regions' in aggregations
        ? aggregations.regions
        : {
            rhs1: [],
            rhs2: [],
            rhs3: [],
            rhs4: [],
            rhs5: [],
        };
    return {
        total,
        rhsLevel: rhsLevel,
        aggregations: {
            ...aggregations,
            features: (0, mapPropertiesToCommon_1.populateFeatureTranslations)(aggregations.features, language),
            ...(hasSiteFeatures && {
                siteFeatures: (0, mapPropertiesToCommon_1.populateFeatureTranslations)(aggregations.siteFeatures, language),
            }),
            regions: (0, mapPropertiesToCommon_1.mapSearchPropertiesEndpointRegionsToCommonRegions)(aggregationsRegions),
            reviews: (0, mapPropertiesToCommon_1.mapSearchPropertiesEndpointReviewsToCommonAggregationReviews)(aggregations.reviews),
        },
        properties: (0, mapPropertiesListToCommonSites_1.mapPropertiesListToCommonSites)(searchResults, summariesResponse, language, elements),
    };
};
exports.mapPropertiesListToCommon = mapPropertiesListToCommon;
//# sourceMappingURL=mapPropertiesListToCommon.js.map